/* TUZEX mobilná lišta – číta stav z výberu veľkosti a z hlavného tlačidla, nič nevymýšľa. */
(() => {
  if (customElements.get('tx-buybar')) return;
  customElements.define('tx-buybar', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info') || document;
      this.btn = this.querySelector('[data-tx-buybar-btn]');
      this.sizeEl = this.querySelector('[data-tx-buybar-size]');
      this.priceEl = this.querySelector('[data-tx-buybar-price]');
      this.mainVisible = true;
      this.hidden = false;
      this.btn.addEventListener('click', () => this.act());
      this.observeMain();
      this.mo = new MutationObserver(() => { this.observeMain(); this.sync(); });
      this.mo.observe(this.root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'hidden', 'data-state'] });
      this.sync();
    }
    disconnectedCallback() { this.mo?.disconnect(); this.io?.disconnect(); document.body.classList.remove('tx-buybar-on'); }
    mainButtons() { return this.root.querySelector('.product-form__buttons') || this.root.querySelector('.tx-sizes'); }
    observeMain() {
      const target = this.mainButtons();
      const picker = this.root.querySelector('.tx-sizes');
      const watch = [target, picker, this.root.querySelector('[data-tx-inquiry]:not([hidden])')].filter(Boolean);
      const key = watch.map((el) => el.className).join('|');
      if (this.io && this.watchKey === key && watch.every((el) => this.watched?.includes(el))) return;
      this.io?.disconnect();
      this.watched = watch; this.watchKey = key;
      this.seen = new Map();
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => this.seen.set(e.target, e.isIntersecting || e.boundingClientRect.top > window.innerHeight));
        // lišta sa ukáže, keď výber veľkosti ani hlavné tlačidlo nie sú vidieť a sme pod nimi
        const anyVisible = [...this.seen.values()].some(Boolean);
        this.mainVisible = anyVisible;
        this.update();
      }, { threshold: 0 });
      watch.forEach((el) => this.io.observe(el));
    }
    state() {
      const field = this.root.querySelector('.tx-sizes__field');
      const s = field?.dataset.state || 'none';
      if (s === 'sold' || s === 'other') return 'request';
      const checked = this.root.querySelector('.tx-sizes__input:checked');
      if (!checked && this.root.querySelector('.tx-sizes')) return 'choose';
      const submit = this.root.querySelector('.product-form__submit');
      if (submit && submit.disabled && !this.root.querySelector('.tx-sizes')) return 'soldout';
      return 'add';
    }
    sync() {
      const st = this.state();
      const d = this.dataset;
      const label = this.root.querySelector('[data-tx-size-label]')?.textContent.trim();
      const fieldPrice = this.root.querySelector('[data-tx-field-price]')?.textContent.trim();
      const sizeText = st === 'choose' ? d.tSize : `${d.tSize} ${label || ''}`.trim();
      if (this.sizeEl.textContent !== sizeText) this.sizeEl.textContent = sizeText;
      // cena: po výbere dostupnej veľkosti presne jej cena, inak „od“ cena produktu
      if (st === 'add' && fieldPrice && fieldPrice !== '—') {
        if (this.priceEl.dataset.mode !== 'size' || this.priceEl.textContent !== fieldPrice) {
          if (!this.priceEl.dataset.fromHtml) this.priceEl.dataset.fromHtml = this.priceEl.innerHTML;
          this.priceEl.textContent = fieldPrice; this.priceEl.dataset.mode = 'size';
        }
      } else if (this.priceEl.dataset.mode === 'size' && this.priceEl.dataset.fromHtml) {
        this.priceEl.innerHTML = this.priceEl.dataset.fromHtml; this.priceEl.dataset.mode = '';
      }
      const text = st === 'choose' ? d.tChoose : st === 'request' ? d.tRequest : st === 'soldout' ? 'Vypredané' : d.tAdd;
      if (this.btn.textContent !== text) this.btn.textContent = text;
      this.btn.dataset.mode = st;
      this.btn.disabled = st === 'soldout';
      this.update();
    }
    update() {
      const show = !this.mainVisible && window.matchMedia('(max-width: 749px)').matches;
      this.classList.toggle('is-visible', show);
      document.body.classList.toggle('tx-buybar-on', show);
    }
    scrollTo(el) {
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    act() {
      const st = this.state();
      if (st === 'choose') {
        const picker = this.root.querySelector('.tx-sizes');
        this.scrollTo(picker);
        const dd = this.root.querySelector('.tx-sizes__dropdown');
        if (dd) setTimeout(() => { dd.open = true; }, 350);
        return;
      }
      if (st === 'request') {
        const box = this.root.querySelector('[data-tx-inquiry]');
        this.scrollTo(box);
        setTimeout(() => box?.querySelector('input[type="email"]')?.focus({ preventScroll: true }), 450);
        return;
      }
      const submit = this.root.querySelector('.product-form__submit');
      if (submit && !submit.disabled) submit.click();
    }
  });
})();
